import { Component, Output, EventEmitter } from '@angular/core'
import { Api } from '../../providers/api'

@Component({
  selector: 'app-invite-modal',
  templateUrl: './invite-modal.component.html',
  styleUrls: ['./invite-modal.component.css']
})
export class InviteModalComponent {

  email = ''
  roleId = 2
  loading = false
  mensaje = ''
  exito = false
  inviteLink = ''
  copiado = false

  @Output() onClose = new EventEmitter<void>()

  constructor(private api: Api) {}

  enviar(): void {
    const email = this.email.trim()
    if (!email || this.loading) return

    this.loading = true
    this.mensaje = ''
    this.inviteLink = ''
    this.copiado = false

    this.api.inviteUser(email, this.roleId).subscribe((res: any) => {
      this.loading = false
      if (res.link) {
        this.inviteLink = res.link
        this.mensaje = 'Invitación generada correctamente.'
        this.exito = true
      } else {
        this.mensaje = res.message || 'Invitación procesada.'
        this.exito = true
      }
    }, (err) => {
      this.loading = false
      this.mensaje = (err.error && err.error.message) || 'Error al generar la invitación.'
      this.exito = false
    })
  }

  copiarLink(input: HTMLInputElement): void {
    input.select()
    document.execCommand('copy')
    this.copiado = true
    setTimeout(() => this.copiado = false, 2000)
  }

  cerrar(): void {
    this.onClose.emit()
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/invite-modal/invite-modal.component.ts